export enum LinesSource {
  NONE = 'none',
  CURATED = 'curated',
  ORIGINAL = 'original'
}
